export const PAGE_TITLE = 'Numbers - Bulk Operations - Microsoft Teams';

// Query key prefix for the numbers list, so a bulk run can patch the cache.
export const TEAMS_BULK_NUMBERS_KEY = 'teamsBulkNumbers';

export const VIEW_MODES = {
    FULL: 'full',
    SPLIT: 'split',
    SELECTED: 'selected',
};

export const TRUNK_KINDS = {
    OC: 'oc',
    DR: 'dr',
    OTHER: 'other',
    NONE: '',
};

export const OC_TRUNK_TYPE_NAME = 'MS Operator Connect';
export const DR_TRUNK_TYPE_NAME = 'MS Direct Routing';

// Teams Phone Mobile numbers are managed through their own disassociate flow
// (see MicrosoftTeamsSection), so they are shown but cannot be bulk updated.
export const OC_MOBILE_USAGE = 'OCMobile';

export const SELECTION_TIP =
    "Hold Shift and tick another number to select everything in between. Greyed out numbers (processing, no user assigned, or Teams Phone Mobile) can't be selected.";

// Both panes share one height so their footers line up in Split View.
export const PANE_HEIGHT = 'calc(100vh - 210px)';
// The Bulk Update status banner takes a fixed slice off that while it shows
// (its height plus the 16px gap below it), so the page doesn't start to scroll.
export const STATUS_BANNER_HEIGHT = '72px';
export const PANE_HEIGHT_WITH_BANNER = 'calc(100vh - 298px)';
export const PANE_MIN_HEIGHT = '480px';
export const FOOTER_BUTTON_WIDTH = '150px';

// The grey toolbar band of AGGridSearchBar (the Numbers page table toolbar),
// so the lists here read the same way.
export const TOOLBAR_BAND_BG = { light: '#EEE', dark: '#1a1a1a' };

/**
 * Modals keep one height while their content changes, and their body scrolls
 * on short screens instead (same approach as ConfirmNumbersModal).
 */
export const fixedModalHeight = (maxHeight) => ({
    marginTop: '30px',
    marginBottom: '30px',
    height: 'calc(100vh - 60px)',
    maxHeight,
});

// How far a list must be scrolled before the back-to-top button shows.
export const SCROLL_TOP_THRESHOLD = 300;
